
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.623 34.315a.998.998 0 00-1.18-.78l-7.46 1.56a16.81 16.81 0 00-13-12.07c.3-.022.597-.062.89-.12a3.45 3.45 0 002.2-1.5 3.479 3.479 0 00-1.01-4.83 3.448 3.448 0 00-2.62-.5 17.202 17.202 0 00-6.76 3.76 17.11 17.11 0 00-7.72-.74 3.5 3.5 0 00-2.7 4.13 3.5 3.5 0 003.41 2.78 3.53 3.53 0 00.72-.08c.299-.07.593-.156.88-.26a16.79 16.79 0 00-6.92 17.26 1 1 0 001 .79c.07.01.14.01.21 0l21.81-4.55 9.08-1.9 8.39-1.75a1 1 0 00.78-1.2zm-10.6 1.19l-7.1 1.48a23.75 23.75 0 00-7.45-12.26 14.78 14.78 0 0114.55 10.78zm-19.78 4.13c-.93-5.77.49-11.51 2.6-14.34 3.07 1.75 6.66 6.44 8.12 12.1l-10.72 2.24zm3.12-16.73l-.08-.4c.41.11.82.2 1.22.27-.37.03-.75.08-1.14.13zm5.52-4.87a1.471 1.471 0 011.12.21 1.478 1.478 0 01.64.94 1.47 1.47 0 01-.21 1.12 1.48 1.48 0 01-.94.64 15.49 15.49 0 01-5.62-.34 15.31 15.31 0 015.01-2.57zm-13.87 5.93a1.482 1.482 0 01-1.548-2.268c.216-.33.553-.56.938-.642a9.051 9.051 0 011.67-.12c1.331-.003 2.657.155 3.95.47a15.631 15.631 0 01-5.01 2.56zm6.31-1.06l.09.41c-.39.11-.76.22-1.13.35.36-.25.7-.49 1.04-.76zm-1.13 2.93a23.76 23.76 0 00-1.91 14.21l-7.1 1.48a14.77 14.77 0 019.01-15.69z"}})])
          )
        }
      }
    